package com.trevorwiebe.timesheet.calendar.domain

actual fun vibrate() {
    // No vibration on web
}

actual fun vibrateTick() {
    // No vibration on web
}
